export default "__VITE_ASSET__d5e1341c__"